import React from "react";
import { formatPrice } from "../../lib/api";

const Stat = ({ label, value }) => (
  <div className="bg-white border border-line p-5">
    <p className="overline mb-2">{label}</p>
    <p className="font-display text-3xl tracking-tight font-bold">{value}</p>
  </div>
);

const AdminStats = ({ stats }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-px bg-line border border-line mb-10">
    <Stat label="Paid orders" value={stats.paidOrders} />
    <Stat label="Gross (GBP)" value={formatPrice(stats.grossRevenue, "GBP")} />
    <Stat label="Team enquiries" value={stats.teamEnquiries} />
    <Stat label="Subscribers" value={stats.subscribers} />
    <Stat label="Messages" value={stats.messages} />
    <Stat label="Reviews" value={stats.reviews} />
    <Stat label="Images" value={stats.images} />
  </div>
);

export default AdminStats;
